import { LossOfEligibilityValues } from './loss-of-eligibility-values';

export const LossOfEligibilityLabels = {
	[LossOfEligibilityValues.DayFollowing]: $.__('Day following termination'),
	[LossOfEligibilityValues.Manual]: $.__('On a manually entered date'),
	[LossOfEligibilityValues.MonthFollowing]: $.__('1st of the month following termination'),
};
